<template>
  <div class="home">
    <Start />
    <Contact />
    <Services />
    <Projects />
    <Team />
    <Carrier />
  </div>
</template>

<script>
  import Start from "./home/Start.vue";
  import Services from "./home/Services.vue";
  import Contact from "./home/Contact.vue";
  import Projects from "./home/Projects.vue";
  import Team from "./home/Team.vue";
  import Carrier from "./home/Carrier.vue";

  export default {
    name: 'Home',
    components: {
      Start,
      Contact,
      Services,
      Projects,
      Team,
      Carrier,
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/styles/home.scss';
</style>
